import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAccountMembershipUsageByLicenseTypeQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetAccountMembershipUsageByLicenseTypeQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, usageByLicenseType: { __typename?: 'SeatUsageByLicenseTypeMapping', member?: { __typename?: 'SeatUsage', availableSeats?: number | null, isHardLimit: boolean } | null } } | null };


export const GetAccountMembershipUsageByLicenseType = /*#__PURE__*/ gql`
    query GetAccountMembershipUsageByLicenseType($accountId: ID!) {
  account(accountId: $accountId) {
    id
    usageByLicenseType {
      member {
        availableSeats
        isHardLimit
      }
    }
  }
}
    ` as unknown as DocumentNode<GetAccountMembershipUsageByLicenseTypeQuery, GetAccountMembershipUsageByLicenseTypeQueryVariables>;

          

          export const useGetAccountMembershipUsageByLicenseTypeQuery = (options?:QueryHookOptions<GetAccountMembershipUsageByLicenseTypeQuery, GetAccountMembershipUsageByLicenseTypeQueryVariables>) => useQuery(GetAccountMembershipUsageByLicenseType, options);

          

          export type GetAccountMembershipUsageByLicenseTypeQueryOptions = QueryHookOptions<GetAccountMembershipUsageByLicenseTypeQuery, GetAccountMembershipUsageByLicenseTypeQueryVariables>;

          

          export const useGetAccountMembershipUsageByLicenseTypeLazyQuery = (options?:LazyQueryHookOptions<GetAccountMembershipUsageByLicenseTypeQuery, GetAccountMembershipUsageByLicenseTypeQueryVariables>) => useLazyQuery(GetAccountMembershipUsageByLicenseType, options);

          

          export type GetAccountMembershipUsageByLicenseTypeQueryResult = ReturnType<typeof useGetAccountMembershipUsageByLicenseTypeQuery>;

          
